import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Home, Search, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <main className="flex min-h-screen flex-col">
      <Helmet>
        <title>Page Not Found - 404 Error</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="The page you're looking for could not be found." />
      </Helmet>
      
      <Navbar />
      
      <section className="flex-1 flex items-center justify-center py-20 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
            <h2 className="text-3xl font-semibold mb-4">Page Not Found</h2>
            <p className="text-lg text-muted-foreground mb-8">
              Sorry, we couldn't find the page you're looking for. The page may have been moved, deleted, or the URL might be incorrect.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link to="/">
              <Button className="w-full sm:w-auto">
                <Home className="mr-2 h-4 w-4" />
                Back to Homepage
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="w-full sm:w-auto">
                <Search className="mr-2 h-4 w-4" />
                Contact Us
              </Button>
            </Link>
          </div>

          <div className="bg-background-light dark:bg-background-dark p-6 rounded-lg border border-border">
            <h3 className="text-xl font-semibold mb-4">Popular Pages</h3>
            <nav className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left">
              <Link to="/" className="text-primary hover:underline flex items-center">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Secondary Glazing Solutions
              </Link>
              <Link to="/get-quote" className="text-primary hover:underline flex items-center">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Get a Free Quote
              </Link>
              <Link to="/acoustic-glazing" className="text-primary hover:underline flex items-center">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Acoustic Glazing
              </Link>
              <Link to="/heritage-preservation-secondary-glazing" className="text-primary hover:underline flex items-center">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Heritage Preservation
              </Link>
              <Link to="/locations" className="text-primary hover:underline flex items-center">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Service Locations
              </Link>
              <Link to="/blog-secondary-glazing" className="text-primary hover:underline flex items-center">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Blog & Resources
              </Link>
            </nav>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
